//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TDP.js";
import "../no/Builder.js";
import "../TDP/TDP.AttributesToExcludeBuilder.js";
import "../no/SelectViewList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AttachSVG",1,0],[1,"AttributesToExclude",0,"TDP.AttributesToExcludeBuilder",0],[0,"BackgroundColor",1,0],[0,"Compression",1,0],[0,"ModelAccuracy",1,0],[0,"OutputFilename",1,0],[0,"OverrideColors",1,0],[0,"PmiColor",1,0],[0,"SaveToOption",1,0],[1,"SelectedViews",0,"SelectViewList",0],[0,"UsePassword",1,0],[0,"ViewSelection",1,0]],[[[],"Publish",{R_:{result:''}},0,0],[[],"GetWorkTemplateFilename",{R_:{templateFilename:''}},0,0],[["templateFilename"],"SetWorkTemplateFile",{},1,0],[["label","value"],"SetTextValueOfLabel",{R_:{exists:''}},2,0],[["label","value"],"SetViewPortViewValueOfViewPortLabel",{R_:{exists:''}},2,0],[["label"],"HasViewportOfLabel",{R_:{exists:''}},1,0],[["label"],"HasTextOfLabel",{R_:{exists:''}},1,0],[["label","value"],"GetTextValueOfLabel",{R_:{exists:''}},1,0],[["numberOflabels","labels"],"GetTextLabels",{},0,0],[["numberOflabels","labels"],"GetViewportLabels",{},0,0],[["password"],"SetPassword",{},1,0],[["filename"],"AddAttachment",{},1,0],[["indices"],"DeleteAttachmentAtIndices",{},1,0],[["numberOfAttachments","attachments"],"GetAttachments",{},0,0],[["generateJT"],"SetGenerateJt",{},1,0]],[]];
SPLM.TDP.PublisherBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.TDP.PublisherBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.TDP.PublisherBuilder.ViewSelectionType = Object.freeze({
    "SelectedViews" : "SelectedViews", "AllDisclosedViews" : "AllDisclosedViews", "AllUserDefinedViews" : "AllUserDefinedViews", "AllViews" : "AllViews", "AllSectionViews" : "AllSectionViews"});

SPLM.TDP.PublisherBuilder.ModelAccuracyType = Object.freeze({
    "Maximum" : "Maximum", "High" : "High", "Medium" : "Medium", "Low" : "Low"});

SPLM.TDP.PublisherBuilder.SaveToOptionType = Object.freeze({
    "Teamcenter" : "Teamcenter", "OperatingSystem" : "OperatingSystem"});

SPLM.TDP.PublisherBuilder.PublishResult = Object.freeze({
    "Success" : "Success", "SuccessWithInconsistency" : "SuccessWithInconsistency", "SuccessWithError" : "SuccessWithError", "Fail" : "Fail"});

export default SPLM;